import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PageTitle } from '@cordata/buffet';
import { format } from 'date-fns';

import { UncontrolledTable } from '~/components/common';
import { getBadgeClass } from '~/components/SendgridEvent/Form';

import { useAdmin } from '~/utils/admin';
import { adminInstance as admin, toastSuccess, toastError } from '~/utils';

const defaultSorted = [{
  id: 'timestamp',
  desc: true,
}];

const columns = [{
  id: 'timestamp',
  Header: 'Date',
  accessor: 'attributes.sendgridTimestamp',
  Cell: c => (c.value ? format(c.value, 'ddd MMM Do YYYY [@] h:mm A') : 'N/A'),
}, {
  id: 'email',
  Header: 'Email Address',
  accessor: 'attributes.email',
}, {
  id: 'event',
  Header: 'Event Type',
  accessor: 'attributes.event',
  Cell: c => (
    <span className={`badge badge-${getBadgeClass(c.value)}`}>
      {c.value || 'unknown'}
    </span>
  ),
}, {
  id: 'reason',
  Header: 'Reason',
  accessor: 'attributes.reason',
}];

const SendgridEvents = () => {
  const history = useHistory();
  const { org } = useAdmin();

  const sendTestMessage = () => {
    admin
      .post('/sendgrid/test', {
        orgUid: org.id,
      })
      .then(() => toastSuccess('Test message sent successfully!'))
      .catch(e => {
        console.error('Failed to send test message', e);
        toastError('Failed to send test message');
      });
  };

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            size="sm"
            onClick={sendTestMessage}
          >
            <FontAwesomeIcon icon="envelope" />
            <span className="d-none d-md-inline ml-2">Send Test Message</span>
          </Button>
        }
      >
        Sendgrid Events
      </PageTitle>

      {org &&
        <UncontrolledTable
          name="sendgrid-events"
          defaultSorted={defaultSorted}
          endpoint={{
            url: 'admin/sendgrid_event',
            params: {
              'org-uid': org.id,
            },
          }}
          columns={columns}
          getTrProps={(state, rowInfo) => ({
            style: {
              cursor: 'pointer',
            },
            onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/admin/sendgrid-events/${rowInfo.original.id}`)),
          })}
        />
      }
    </>
  );
};

SendgridEvents.propTypes = {};

export default SendgridEvents;
